/**
 * Method open url with target
 *
 * @param url
 * @param target
 */
export const goToLinkWithTarget = (url, target = '_blank') => {
  window.open(url, target);
};
